import React, { useEffect, useState } from 'react'
import OTPInput from 'react-otp-input'
import { useNavigate } from 'react-router-dom';
import logo from '../../../assets/img/logo-nanny.png';
import { useDispatch, useSelector } from 'react-redux';
import { clearOtpData, verifyOtp } from '../../../store/apiSlice/Otpslice';
import { clearSignupData } from '../../../store/apiSlice/Signupnannyslice';
import { clearFamilyData } from '../../../store/apiSlice/SignupfamilySilce';
import { ClipLoader } from "react-spinners";


const PhoneOtp = () => {

    const [phoneOtp, setPhoneOtp] = useState('');

    const dispatch = useDispatch();
    const data = useSelector((state) => state.rootReducer.phoneOtp.data);
    const isLoading = useSelector((state) => state.rootReducer.phoneOtp.loading);
    const signUpData = useSelector((state) => state.rootReducer.signUp.data);
    const signUpDataFamily = useSelector((state) => state.rootReducer.signUpfamily.data);

    const handleOtpVerification = async () => {
        const emailVerify =
            signUpData != null ? signUpData.data.phoneOtp == phoneOtp ? 1 : signUpData.data.otpPhone == phoneOtp ? 2 : 3 : signUpDataFamily.data.phoneOtp == phoneOtp ? 1 : signUpDataFamily.data.otpPhone == phoneOtp ? 2 : 3
        if (emailVerify != 3) {
            const payload = {
                _id: signUpData != null ? signUpData.data._id : signUpDataFamily.data._id,
                phoneOtp: phoneOtp,
                emailVerify: emailVerify,
            }
            try {
                dispatch(verifyOtp(payload));
            } catch (error) {
                console.error('phoneOtp failed:', error);
            }
        } else if (phoneOtp.length == 0) {
            alert("Please enter your phoneOtp");
        } else if (phoneOtp.length == 1) {
            alert("Please enter your full phoneOtp");
        } else if (phoneOtp.length == 2) {
            alert("Please enter your full phoneOtp");
        } else if (phoneOtp.length == 3) {
            alert("Please enter your full phoneOtp");
        } else if (phoneOtp.length == 4) {
            alert("Please enter your full phoneOtp");
        } else if (phoneOtp.length == 5) {
            alert("Please enter your full phoneOtp");
        }
    };

    const navigate = useNavigate();

    const navigateToAnotherScreen = () => {
        dispatch(clearFamilyData());
        dispatch(clearOtpData());
        dispatch(clearSignupData());
        navigate('/login');
        window.location.reload();
    }

    useEffect(() => {
        if (data != null && data.status === 1) {
            navigateToAnotherScreen();
        }
    }, [data])

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="container py-5">
                        <a href="#" className="custom-logo d-block login-logo mx-auto">
                            <img className="mw-100" src={logo} alt="logo" />
                        </a>
                        <div className="row">
                            <div className="col-lg-6 offset-lg-3 offset-sm-1 col-sm-10">
                                <div className="login_layout p-5 shadow-sm p-3 mb-5 bg-body rounded">
                                    <div className='otp_text'>
                                        <h6>Phone OTP Verification</h6>
                                    </div>
                                    <form className="w-100 mb-4 input_otp" appearance="outline">
                                        <OTPInput
                                            value={phoneOtp}
                                            onChange={(value) => setPhoneOtp(value)}
                                            numInputs={6}
                                            renderSeparator={<span className='space'></span>}
                                            renderInput={(props) => <input {...props} />}
                                        />
                                    </form>
                                    <div className="d-flex flex-column align-items-center justify-content-center">
                                        <button type='button' color="primary" className="login_button px-4 btn all_btn" onClick={() => handleOtpVerification()} >
                                            {isLoading ? (
                                                <ClipLoader color="#fff" />
                                            ) : (
                                                "Verify"
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    )
}

export default PhoneOtp